<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jknumberedit  label="上卦" #TL008Com  id="TL008"  [(value)]="item.TL008" placeholder="上卦"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkdatefield  label="DateTime" #TL013Com  id="TL013"  [(date)]="item.TL013" placeholder="DateTime"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkedit  label="性別" #TL012Com  id="TL012"  [(value)]="item.TL012" placeholder="性別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="年齡" #TL011Com  id="TL011"  [(value)]="item.TL011" placeholder="年齡"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="變爻" #TL010Com  id="TL010"  [(value)]="item.TL010" placeholder="變爻"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="下卦" #TL009Com  id="TL009"  [(value)]="item.TL009" placeholder="下卦"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jktext  label="單號" [value]="item.TL001"     >
    </app-jktext>
    <app-jktextarea  height="250px" 
 label="回答" #TL007Com  id="TL007"  [(value)]="item.TL007" placeholder="回答"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="問題" #TL006Com  id="TL006"  [(value)]="item.TL006" placeholder="問題"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkedit  label="分類" #TL005Com  id="TL005"  [(value)]="item.TL005" placeholder="分類"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="時間" [value]="item.TL004"     >
    </app-jktext>
    <app-jkedit  label="問卦者" #TL003Com  id="TL003"  [(value)]="item.TL003" placeholder="問卦者"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="日期" #TL002Com  id="TL002"  [(value)]="item.TL002" placeholder="日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>

    </div>
  </div>
</div>